import { getCvvMaxLength } from '@openeducation/pp-js-utils';
import type { CreditCard } from '@openeducation/pp-rn-shared-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { TextInputProps, TextInput } from '../../../atoms';
import { InputRow } from '../../../molecules';

interface PaymentInfoCvvProps extends TextInputProps {
  cardType?: CreditCard;
  error?: string;
}

const PaymentInfoCvv = ({
  onFocus,
  onBlur,
  value,
  onValueChange,
  cardType,
  error,
}: PaymentInfoCvvProps) => {
  const { t } = useTranslation();

  const maxLength = getCvvMaxLength(cardType);

  return (
    <InputRow label={t('input.card_code.label')} error={error}>
      <TextInput
        name="cvv"
        value={value}
        maxLength={maxLength}
        keyboardType="numeric"
        placeholder="CVV"
        onFocus={onFocus}
        onBlur={onBlur}
        onValueChange={onValueChange}
      />
    </InputRow>
  );
};

export default memo(PaymentInfoCvv);
